import { render, staticRenderFns } from "./voicemailPlayer.vue?vue&type=template&id=3bcdcc64&scoped=true&"
import script from "./voicemailPlayer.vue?vue&type=script&lang=js&"
export * from "./voicemailPlayer.vue?vue&type=script&lang=js&"
import style0 from "./voicemailPlayer.vue?vue&type=style&index=0&id=3bcdcc64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdcc64",
  null
  
)

export default component.exports